import _ from 'underscore';

let i18n = null;

export function initialize(options) {
  i18n = options.passedInI18n;
}

export function updateEntitySchemaForIsAppealPending(entitySchema) {
  _.extend(entitySchema.properties, {
    IsAppealPending: {
      name: 'IsAppealPending',
      localized: {
        true: i18n.getString('Is_Appeal_Pending_True'),
        false: i18n.getString('Is_Appeal_Pending_False'),
      },
      chooseType: 'select',
      filterable: true,
      property: 'IsAppealPending',
      type: 'boolean',
      title: i18n.getString('IsAppealPending'),
    },
  });

  return entitySchema;
}
